export default "__VITE_ASSET__BGDw_if0__"